import React, { useState } from 'react';
import './TourCard.css';

const TourCard = ({ tour }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  
  // Calculate nights (days - 1)
  const nights = tour.days - 1;
  
  // Split description into points - handle newlines, commas, and periods
  let descriptionPoints = [];
  
  // First check for newlines
  if (tour.description.includes('\n')) {
    descriptionPoints = tour.description
      .split('\n')
      .map(point => point.trim())
      .filter(point => point.length > 0);
  } else if (tour.description.includes('.') || tour.description.includes(',')) {
    // Then check for periods or commas
    descriptionPoints = tour.description
      .split(/[.,]/)
      .map(point => point.trim())
      .filter(point => point.length > 0);
  } else {
    // If no punctuation, treat as single point
    descriptionPoints = [tour.description];
  }
  
  const firstTwoPoints = descriptionPoints.slice(0, 2);
  const hasMorePoints = descriptionPoints.length > 2;
  
  const handleReadMore = () => {
    setIsFlipped(!isFlipped);
  };
  
  return (
    <div className={`tour-card ${isFlipped ? 'flipped' : ''}`}>
      <div className="tour-card-inner">
        {/* Front Side */}
        <div className="tour-card-front">
          {/* Discount Badge */}
          {tour.discount && tour.discount > 0 && (
            <div className="discount-badge">
              {tour.discount}% OFF
            </div>
          )}
          <div className="tour-image">
            <img src={tour.image} alt={tour.name} />
            <div className="tour-days">{nights}N/{tour.days}D</div>
          </div>
          
          {/* Icons Section - show only selected amenities */}
          <div className="tour-icons">
            {tour.amenities && tour.amenities.includes('Flight') && (
              <div className="icon-item">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>
                </svg>
                <span>Flight</span>
              </div>
            )}
            {tour.amenities && tour.amenities.includes('Hotels') && (
              <div className="icon-item">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V7H1v13h2v-2h18v2h2v-9c0-2.21-1.79-4-4-4z"/>
                </svg>
                <span>Hotels</span>
              </div>
            )}
            {tour.amenities && tour.amenities.includes('Sightseeing') && (
              <div className="icon-item">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
                <span>Sightseeing</span>
              </div>
            )}
            {tour.amenities && tour.amenities.includes('Meals') && (
              <div className="icon-item">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"/>
                </svg>
                <span>Meals</span>
              </div>
            )}
            {tour.amenities && tour.amenities.includes('Transfers') && (
              <div className="icon-item">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
                </svg>
                <span>Transfers</span>
              </div>
            )}
          </div>
          
          <div className="tour-content">
            <h3 className="tour-name">{tour.name}</h3>
            
            {/* Show only first 2 points */}
            <div className="tour-description">
              <div className="package-inclusion">PACKAGE INCLUSION:</div>
              <ul className="description-points">
                {firstTwoPoints.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>
            
            {/* Features Section */}
            {tour.features && tour.features.length > 0 && (
              <div className="tour-features">
                <div className="features-header">FEATURES:</div>
                <div className="feature-badges">
                  {tour.features.slice(0, 3).map((feature, index) => (
                    <span key={index} className="feature-badge">{feature}</span>
                  ))}
                  {tour.features.length > 3 && (
                    <span className="feature-more">+{tour.features.length - 3} more</span>
                  )}
                </div>
              </div>
            )}
            
            {hasMorePoints && (
              <button className="read-more-btn" onClick={handleReadMore}>
                Read More
              </button>
            )}
            
            <div className="tour-footer">
              <div className="tour-price">
                <span className="price-label">From</span>
                <span className="price-amount">Rs.{tour.price}</span>
              </div>
              <a
                className="book-button"
                href={
                  `https://wa.me/919625653930?text=${encodeURIComponent(
                    `I want to enquire about this: ${window.location.origin}/tour/${tour.id} (${tour.name})`
                  )}`
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                Enquiry now
              </a>
            </div>
          </div>
        </div>
        
        {/* Back Side */}
        <div className="tour-card-back">
          <div className="tour-content">
            <h3 className="tour-name">{tour.name}</h3>
            <div className="tour-days-info">{nights}N/{tour.days}D</div>
            
            <div className="tour-description">
              <div className="package-inclusion">PACKAGE INCLUSION:</div>
              <ul className="description-points">
                {descriptionPoints.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>
            
            {/* Features Section - Full list on back */}
            {tour.features && tour.features.length > 0 && (
              <div className="tour-features">
                <div className="features-header">FEATURES:</div>
                <div className="feature-badges">
                  {tour.features.map((feature, index) => (
                    <span key={index} className="feature-badge">{feature}</span>
                  ))}
                </div>
              </div>
            )}
            
            <button className="read-more-btn" onClick={handleReadMore}>
              Back to Card
            </button>
            
            <div className="tour-footer">
              <div className="tour-price">
                <span className="price-label">From</span>
                <span className="price-amount">Rs.{tour.price}</span>
              </div>
              <a
                className="book-button"
                href={
                  `https://wa.me/919625653930?text=${encodeURIComponent(
                    `I want to enquire about this: ${window.location.origin}/tour/${tour.id} (${tour.name})`
                  )}`
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                Enquiry now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourCard;
